import { UPDATEPROJECTSTATUS_SUCCESS, UPDATEPROJECTSTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const updateProjectStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEPROJECTSTATUS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEPROJECTSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateProjectStatusReducer;
